import { combineReducers } from "redux";
import { identityProviderDetailsReducer } from "./identity-provider-details-reducer";
import { identityProvidersReducer } from "./identity-providers-reducer";
import { organizationDetailsReducer } from "./organization-details-reducer";
import { organizationsReducer } from "./organizations-reducer";
import { organizationInvitationsReducer } from "./organization-invitations-reducer";
import { organizationInvitationDetailsReducer } from "./organization-invitation-details-reducer";
import { organizationUsersReducer } from "./organization-users-reducer";
import { relyingPartiesReducer } from "./relying-parties-reducer";
import { relyingPartyDetailsReducer } from "./relying-party-details-reducer";
import { sessionReducer } from "./session-reducer";
import { verificationServiceDetailsReducer } from "./verification-service-details-reducer";
import { verificationServicesReducer } from "./verification-services-reducer";
import { workflowsReducer } from "./workflows-reducer";
import { workflowUsageDetailsReducer } from "./workflow-usage-details-reducer";
import { organizationUserDetailsReducer } from "./organization-user-details-reducer";
import { attributeLabelDetailsReducer } from "./attribute-label-details-reducer";
import { attributeLabelsReducer } from "./attribute-labels-reducer";
import { axnCacheReducer } from "./axn-cache-reducer";
import { axnConfigReducer } from "./axn-config-reducer";
import { axnSessionsReducer } from "./axn-sessions-reducer";
import { axnAdminCacheReducer } from "./axn-admin-cache-reducer";
import { axnAdminConfigReducer } from "./axn-admin-config-reducer";
import { axnAdminLoggingReducer } from "./axn-admin-logging-reducer";
import { securityRulesReducer } from "./security-rules-reducer";
import { axnAdminSessionsReducer } from "./axn-admin-sessions-reducer";
import { alertEventsReducer } from "./alert-events-reducer";
import { adaptiveAuthenticationReducer } from "./adaptive-authentication-reducer";
import { userSummaryReducer } from "./user-summary-reducer";
import { fraudReportReducer } from "./fraud-report-reducer";
import { serviceAssertionPerformanceReducer } from "./service-assertion-performance-reducer";
import { serviceAssertionPerformanceComparisonReducer } from "./service-assertion-performance-comparison-reducer";
import { verificationTransactionsReducer } from "./verification-transactions-reducer";
import { appAlertsReducer } from "./app-alerts-reducer";
import { verificationTransactionDetailsReducer } from "./verification-transaction-details-reducer";
import { organizationActivityReducer } from "./organization-activity-reducer";
import { workflowReportReducer } from "./workflow-report-reducer";
import { dashboardReducer } from "./dashboard-reducer";
import { workflowDetailsReducer } from "./workflow-details-reducer";
import { loadingIndicatorsReducer } from "./loading-indicators-reducer";
import { workflowTemplatesReducer } from "./workflow-templates-reducer";
import { workflowTemplateDetailsReducer } from "./workflow-template-details-reducer";
import { policyComponentDetailsReducer } from "./policy-component-details-reducer";
import { policyComponentsReducer } from "./policy-components-reducer";
import { commonReferenceDataReducer } from "./common-reference-data-reducer";
import { messagingTemplatesReducer } from "./messaging-templates-reducer";
import { messagingTemplateDetailsReducer } from "@redux/reducers/messaging-template-details-reducer";
import { tableSettingsReducer } from "./table-settings-reducer";
import { serviceTemplatesReducer } from "@redux/reducers/service-templates-reducer";
import { serviceTemplateDetailsReducer } from "@redux/reducers/service-template-details-reducer";
import { emailTemplateDetailsReducer } from "@redux/reducers/email-template-details-reducer";
import { emailTemplatesReducer } from "@redux/reducers/email-templates-reducer";

export const rootReducer = combineReducers({
    adaptiveAuthentication: adaptiveAuthenticationReducer,
    alertEvents: alertEventsReducer,
    appAlerts: appAlertsReducer,
    attributeLabelDetails: attributeLabelDetailsReducer,
    attributeLabels: attributeLabelsReducer,
    axnAdminCache: axnAdminCacheReducer,
    axnAdminConfig: axnAdminConfigReducer,
    axnAdminLogging: axnAdminLoggingReducer,
    axnAdminSessions: axnAdminSessionsReducer,
    axnCache: axnCacheReducer,
    axnConfig: axnConfigReducer,
    axnSessions: axnSessionsReducer,
    commonReferenceData: commonReferenceDataReducer,
    dashboard: dashboardReducer,
    fraudReport: fraudReportReducer,
    identityProviders: identityProvidersReducer,
    identityProviderDetails: identityProviderDetailsReducer,
    loadingIndicators: loadingIndicatorsReducer,
    messagingTemplateDetails: messagingTemplateDetailsReducer,
    messagingTemplates: messagingTemplatesReducer,
    emailTemplateDetails: emailTemplateDetailsReducer,
    emailTemplates: emailTemplatesReducer,
    organizationActivity: organizationActivityReducer,
    organizationUserDetails: organizationUserDetailsReducer,
    organizationDetails: organizationDetailsReducer,
    organizations: organizationsReducer,
    organizationInvitations: organizationInvitationsReducer,
    organizationInvitationDetails: organizationInvitationDetailsReducer,
    organizationUsers: organizationUsersReducer,
    policyComponents: policyComponentsReducer,
    policyComponentDetails: policyComponentDetailsReducer,
    relyingParties: relyingPartiesReducer,
    relyingPartyDetails: relyingPartyDetailsReducer,
    securityRules: securityRulesReducer,
    serviceAssertionPerformance: serviceAssertionPerformanceReducer,
    serviceAssertionPerformanceComparison: serviceAssertionPerformanceComparisonReducer,
    serviceTemplates: serviceTemplatesReducer,
    serviceTemplateDetails: serviceTemplateDetailsReducer,
    session: sessionReducer,
    tableSettings: tableSettingsReducer,
    userSummary: userSummaryReducer,
    verificationServiceDetails: verificationServiceDetailsReducer,
    verificationServices: verificationServicesReducer,
    verificationTransactionDetails: verificationTransactionDetailsReducer,
    verificationTransactions: verificationTransactionsReducer,
    workflowReport: workflowReportReducer,
    workflows: workflowsReducer,
    workflowDetails: workflowDetailsReducer,
    workflowTemplates: workflowTemplatesReducer,
    workflowTemplateDetails: workflowTemplateDetailsReducer,
    workflowUsageDetails: workflowUsageDetailsReducer
});